var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_box"},[_c('div',{staticClass:"page_table_box",staticStyle:{"height":"calc(100% - 10px)"}},[_c('div',{staticClass:"school_table_box center"},[_c('img',{attrs:{"src":require("@/assets/img/noData/no-authority.png"),"alt":"暂无权限"}})])])])
}]

export { render, staticRenderFns }